import React from "react";
import Modal from "../modal";
import styles from "./styles.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { setPromocodePopupAction } from "../../store/promocodeReducer";
import Button from "../UI/button";
const PromocodePopup = ({ discountPercentage, promocode }) => {
	const dispatch = useDispatch();
	const { show } = useSelector((store) => store.promocode);

	const onModalClose = () => {
		dispatch(setPromocodePopupAction(false));
	};
	const modalContent = (
		<div className={styles.popupContent}>
			<div className={styles.discountCircle}>
				<span>{discountPercentage}%</span>
			</div>
			<h3>Поздравляем!</h3>
			<p>
				Вы получили скидку {discountPercentage}% с использованием промокода:
			</p>
			<div className={styles.promocode}>{promocode}</div>
			<Button
				text="Спасибо"
				onClick={() => {
					onModalClose();
				}}
			/>
		</div>
	);

	return (
		<Modal show={show} onClose={onModalClose}>
			{modalContent}
		</Modal>
	);
};

export default PromocodePopup;
